const setModal = () => {
  const errorModal = document.querySelector('#modal-error');
  const body = document.querySelector('body');

  if(errorModal) {
    const modalBg = errorModal.querySelector('.modal-bg');
    const closeBtn = errorModal.querySelector('.modal-close');

    errorModal.classList.add('is-open');
    body.classList.add('no-scroll');

    closeBtn.addEventListener('click', function() {
      errorModal.classList.remove('is-open');
      body.classList.remove('no-scroll');
    });

    modalBg.addEventListener('click', function() {
      errorModal.classList.remove('is-open');
      body.classList.remove('no-scroll');
    });
  }
}

export default setModal